import React from "react";

class SubjectLine extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            style: {
                //color: "#1d4e92",
                color:"#333",
                //background: "#c7daf4",
                fontWeight: "bold",
                fontSize:"16px",
                cursor:"pointer",
                borderBottom:"1px solid rgb(150, 150, 150)",
            },
            ident: "subject-line",
            class:"norm",
            check:{visibility:"hidden"},
            upArrow:{visibility:"hidden"},
            downArrow:{visibility:"hidden"},
            downDisplay:{display:"inline-block"},
            upDisplay:{display:"none"}
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({check:{visibility:nextProps.check}});
        this.setState({upArrow:{visibility:nextProps.upArrow}});
        this.setState({downArrow:{visibility:nextProps.downArrow}});
    }

    handleAccordion = (that) => {
        this.props.func(that);
    }

    render() {
        var colour = this.props.color;
        return (
            <div style={this.state.style} className={this.state.ident} onClick={() => this.handleAccordion(this)}>

                <p>
                    {/*<span style={this.state.check}>&#10004;</span>*/}
                    <span style={this.state.downDisplay} className={this.state.class}><i className="fa fa-angle-right"></i></span>
                    <span style={this.state.upDisplay} className={this.state.class}><i className="fa fa-angle-down"></i></span>
                    &nbsp;{this.props.subject}
                    <div className="quiver">
                        <span style={this.state.upArrow} className="arrow">&#9650;</span>
                        <span style={this.state.downArrow} className="arrow">&#9660;</span>
                    </div>
                    <span style={{background:colour}} className="badge">{this.props.valu}</span>
                </p>

            </div>
        )
    }
}

export default SubjectLine;


// WEBPACK FOOTER //
// ./src/subject-line.js